module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "title": "审核人设置",
      "width": "600px",
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "reviewer-setting-content"
  }, _vm._l((_vm.localReviewers), function(reviewer) {
    return _c('div', {
      key: reviewer.level,
      staticClass: "reviewer-row"
    }, [_c('el-checkbox', {
      model: {
        value: (reviewer.checked),
        callback: function($$v) {
          _vm.$set(reviewer, "checked", $$v)
        },
        expression: "reviewer.checked"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "reviewer-label"
    }, [_vm._v("\n        " + _vm._s(_vm.getLevelLabel(reviewer.level)) + "级审核人：\n      ")]), _vm._v(" "), _c('el-input', {
      staticClass: "alias-input",
      attrs: {
        "placeholder": "请输入别名",
        "size": "mini"
      },
      model: {
        value: (reviewer.alias),
        callback: function($$v) {
          _vm.$set(reviewer, "alias", $$v)
        },
        expression: "reviewer.alias"
      }
    }), _vm._v(" "), _c('el-radio-group', {
      attrs: {
        "size": "mini"
      },
      model: {
        value: (reviewer.targetType),
        callback: function($$v) {
          _vm.$set(reviewer, "targetType", $$v)
        },
        expression: "reviewer.targetType"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "any"
      }
    }, [_vm._v("任意人")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "designated"
      }
    }, [_vm._v("指定人")])], 1), _vm._v(" "), (reviewer.targetType === 'designated') ? [_c('el-button', {
      staticStyle: {
        "color": "#e6a23c"
      },
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.openUserSelect(reviewer)
        }
      }
    }, [_vm._v("\n          选择\n        ")]), _vm._v(" "), (reviewer.designatedUsers && reviewer.designatedUsers.length > 0) ? _c('span', {
      staticClass: "selected-users"
    }, [_vm._v("\n          （" + _vm._s(reviewer.designatedUsers.map(function (u) { return u.name; }).join(",")) + "）\n        ")]) : _vm._e()] : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保 存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2403f8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/ReviewerSettingDialog.vue
// module id = 2422
// module chunks = 68